import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const SquareMeasureIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 13.936 13.918"
    >
      <defs>
        <clipPath>
          <rect width="13.936" height="13.918" transform="translate(0 0)" fill="none" stroke={color} strokeWidth="1" />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath)">
        <path
          d="M11.914,3.521h.01A1.511,1.511,0,1,0,10.414,2"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M10.414,2v.012a1.51,1.51,0,0,0,1.5,1.51"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M2.013,3.522a1.511,1.511,0,0,0,1.51-1.511V2"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M3.521,2a1.511,1.511,0,1,0-1.51,1.523h0"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M11.914,10.4h.01a1.511,1.511,0,1,1-1.511,1.511V11.9"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M11.914,10.4a1.51,1.51,0,0,0-1.5,1.5"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M2.013,10.355a1.511,1.511,0,0,1,1.51,1.511c0,.012,0,.023,0,.034"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M2.013,10.355h0A1.511,1.511,0,1,0,3.519,11.9"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          y2="6.875"
          transform="translate(11.914 3.521)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          y2="6.833"
          transform="translate(2.013 3.522)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          x2="6.895"
          transform="translate(3.519 11.9)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          x2="6.893"
          transform="translate(3.521 1.999)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  </CircledIcon>
);
